import { FC } from 'react';
import { Card, Grid, Stack } from '@mui/material';
import { useAreasByCustomer } from '@hooks';
import { CompanyPostalAddress } from '@modules/clients/data/PlacesRepository/address/services/getPostalAddressByCustomerId';
import { AreasList, PostalAddressDetail, ProductsAvailableList } from './components';
import { CompanySegmentsList } from './components/CompanySegmentsList/CompanySegmentsList';
import useCustomerLimits from './data/hooks/useCustomerLimits';
interface CompanyDetailsProps {
  customerId: number;
  isOperationRole: boolean;
  companyPostalAddress: CompanyPostalAddress | undefined;
  isLoading: boolean;
  balanceAvailable: string;
}

/** Render company details address */
const CompanyDetails: FC<CompanyDetailsProps> = ({
  customerId,
  isOperationRole,
  companyPostalAddress,
  isLoading: isLoadingCompanyPostalAddress,
  balanceAvailable,
}) => {
  const { data, isLoading: isProductsLoading } = useCustomerLimits();
  const { data: areas, isLoading: isAreasLoading } = useAreasByCustomer({
    allowRequest: isOperationRole,
    customerId,
  });
  return (
    <Grid container spacing={2} direction={'row'}>
      <Grid item xs={12} sm={4}>
        <Card>
          <PostalAddressDetail
            companyPostalAddress={companyPostalAddress}
            isLoading={isLoadingCompanyPostalAddress}
            isOperationRole={isOperationRole}
          />
          {isOperationRole && !isAreasLoading && Boolean(areas?.length) && (
            <AreasList areas={areas} balanceAvailable={balanceAvailable} />
          )}
        </Card>
      </Grid>
      <Grid item xs={12} sm={8}>
        <Stack spacing={2}>
          <CompanySegmentsList segments={data?.segments} />
          {isOperationRole && !isProductsLoading && (
            <ProductsAvailableList products={data?.products ?? []} />
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CompanyDetails;
